import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

export const useHeader = () => {
  const routes = useSelector((state: any) => state.user?.routes);

  const [notificationsFiltered, setNotificationsFiltered] = useState([]);

  const { notifications } = useSelector((state: any) => state.notifications);

  useEffect(() => {
    if (notifications?.notificationList?.length > 0)
      setNotificationsFiltered(
        notifications?.notificationList.filter((notification) => {
          return notification.type === 'Failure' || notification.type === 'Warning' || notification.type === 'Disconnected';
        })
      );
  }, [notifications]);

  const user: any = JSON.parse(localStorage.getItem('auth-user') as string);
  const userName = user?.name;

  return { notificationsFiltered, routes, userName };
};
